import { ref, computed, onMounted, watch } from "vue";
import { adultStorageKey } from "@magnit/unit-catalog/src/unit-catalog.vars";
import Cookie from "@magnit/core/src/utilities/cookie";
import { showAdultCookie } from "@magnit/unit-catalog/src/unit-catalog.types";

export default (initial?: showAdultCookie | null) => {
  const adultCookie = ref<showAdultCookie | undefined | null>(initial);
  const isDialogOpened = ref<boolean>(false);

  const approved = computed(() => adultCookie.value === showAdultCookie.Yes);

  const updateApprove = (v: boolean) => {
    if (v) {
      adultCookie.value = showAdultCookie.Yes;
    }
    isDialogOpened.value = false;
  };

  onMounted(() => {
    adultCookie.value = Cookie.get(adultStorageKey);
  });

  watch(adultCookie, (v) => v && Cookie.set(adultStorageKey, v));

  return {
    isDialogOpened,
    approved,
    updateApprove,
  };
};
